module.exports = __webpack_public_path__ + "media/images/signatures/cover-bg-2021-5443f89311ffc2a7c9b4a7c6dff1267f.png";